import { StreamListener } from '@m43/sockets-mark43';
import { StreamMap } from '../../../types';

/** Identity function for type inference on stream listeners. */
export const createStreamListener = <K extends Readonly<(keyof StreamMap)[]>>(
    streamListener: StreamListener<StreamMap, K>
): StreamListener<StreamMap, K> => {
    return streamListener;
};
